export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";